export interface IPoint {
    longitude: number;
    latitude: number;
}

export interface IMarkerPoint extends IPoint {
    name?: string;
    color?: MarkerColor;
    label?: string;
    size?: MarkerSize;
}

export enum MarkerColor {
    Blue,
    Green,
    Red,
    Default,
}

export enum MarkerSize {
    Default,
    Large,
}